export enum BladeActionType {
  general = "General",
  contract = "Contracts",
  operation = "Operations",
  blackOp = "Black Operations",
}
export enum BladeGeneralActionName {
  training = "Training",
  fieldAnalysis = "Field Analysis",
  recruitment = "Recruitment",
  diplomacy = "Diplomacy",
  hyperbolicRegen = "Hyperbolic Regeneration Chamber",
  inciteViolence = "Incite Violence",
}
export enum BladeContractName {
  tracking = "Tracking",
  bountyHunter = "Bounty Hunter",
  retirement = "Retirement",
}
export enum BladeOperationName {
  investigation = "Investigation",
  undercover = "Undercover Operation",
  sting = "Sting Operation",
  raid = "Raid",
  stealthRetirement = "Stealth Retirement Operation",
  assassination = "Assassination",
}
export enum BladeBlackOpName {
  OperationTyphoon = "Operation Typhoon",
  OperationZero = "Operation Zero",
  OperationX = "Operation X",
  OperationTitan = "Operation Titan",
  OperationAres = "Operation Ares",
  OperationArchangel = "Operation Archangel",
  OperationJuggernaut = "Operation Juggernaut",
  OperationRedDragon = "Operation Red Dragon",
  OperationK = "Operation K",
  OperationDeckard = "Operation Deckard",
  OperationTyrell = "Operation Tyrell",
  OperationWallace = "Operation Wallace",
  OperationShoulderOfOrion = "Operation Shoulder of Orion",
  OperationHyron = "Operation Hyron",
  OperationMorpheus = "Operation Morpheus",
  OperationIonStorm = "Operation Ion Storm",
  OperationAnnihilus = "Operation Annihilus",
  OperationUltron = "Operation Ultron",
  OperationCenturion = "Operation Centurion",
  OperationVindictus = "Operation Vindictus",
  OperationDaedalus = "Operation Daedalus",
}

export enum BladeSkillName {
  bladesIntuition = "Blade's Intuition",
  cloak = "Cloak",
  shortCircuit = "Short-Circuit",
  digitalObserver = "Digital Observer",
  tracer = "Tracer",
  overclock = "Overclock",
  reaper = "Reaper",
  evasiveSystem = "Evasive System",
  datamancer = "Datamancer",
  cybersEdge = "Cyber's Edge",
  handsOfMidas = "Hands of Midas",
  hyperdrive = "Hyperdrive",
}

export enum BladeMultName {
  successChanceAll = "Total Success Chance",
  successChanceStealth = "Stealth Success Chance",
  successChanceKill = "Retirement Success Chance",
  successChanceContract = "Contract Success Chance",
  successChanceOperation = "Operation Success Chance",
  successChanceEstimate = "Synthoid Data Estimate",
  actionTime = "Action Time",
  effStr = "Effective Strength",
  effDef = "Effective Defense",
  effDex = "Effective Dexterity",
  effAgi = "Effective Agility",
  effCha = "Effective Charisma",
  stamina = "Stamina",
  money = "Contract Money",
  expGain = "Experience Gain",
}
